// src/api/apiClient.ts
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL as string;
const headers = { "content-type": "application/json" };

const apiClient = axios.create({
	baseURL,
	headers,
	withCredentials: true,
});


export default apiClient;
